package ai.wagemix.net.client

import com.fsryan.foundation.net.client.FSAuthenticatedRequestBuilder
import com.fsryan.foundation.net.client.FSRequest
import com.fsryan.foundation.net.client.addQueryParam
import com.fsryan.foundation.net.client.queryParamValues

abstract class WMEventStreamReferencingRequestBuilder<
    B: WMEventStreamReferencingRequestBuilder<B, T>,
    T: Any
>: FSAuthenticatedRequestBuilder<B, T>() {

    protected var eventStreamId: String? = null

    fun eventStreamId(eventStreamId: String) = apply {
        this.eventStreamId = eventStreamId
    }

    override fun applyFrom(request: FSRequest<T>): B {
        eventStreamId = request.queryParamValues("eventStreamId").firstOrNull()
        return super.applyFrom(request)
    }

    override fun build(): FSRequest<T> {
        removeQueryParams("eventStreamId")
        with(self()) {
            eventStreamId?.let { addQueryParam("eventStreamId", it) }
        }
        return super.build()
    }

    override fun clear(): B {
        eventStreamId = null
        return super.clear()
    }
}